/**
 * Csv Schema of MotoristaTransbordo
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {MotoristaTransbordo} from '@/model/resource/MotoristaTransbordo'

/* TODO: review generated schema */
export class CsvMotoristaTransbordoSchema extends Schema {
  readonly name = 'CsvMotoristaTransbordo'

  readonly fieldSet: FieldSet<MotoristaTransbordo> = {
    motorista: schema => schema.model.motorista?.$id ?? null,
    podeReceber: schema => Helper.bool(schema.model.podeReceber),
    podeEntregar: schema => Helper.bool(schema.model.podeEntregar),
  }
}
